import React, { Component } from 'react';

export default class ReactTimer extends Component {
  constructor( props ) {
    super( props );
    this.minRefreshRate = 5000;
    this.refreshRatePosition = 0;
    this.state = {
      timer: null,
      refreshRate: props.refreshRate === undefined ? this.minRefreshRate : props.refreshRate,
      loading: props.loading === undefined ? false : props.loading
    };
    this.tick = this.tick.bind( this ) ;
  }
  
  componentDidMount() {

    //Execute the initial refresh
    if( this.props.onTick !== undefined ) {
      this.props.onTick();
    }

    // Setup the timer
    let timer = setInterval( this.tick, 1000 );
    this.setState( { 
      timer: timer
    } );
  }

  componentWillReceiveProps( nextProps ) {
    // Check if refresh rate has changed
    this.setState( {
      refreshRate: ( nextProps.refreshRate === undefined || nextProps.refreshRate < this.minRefreshRate ) ? this.minRefreshRate : nextProps.refreshRate,
      loading: nextProps.loading === undefined ? false : nextProps.loading
    } );
  }

  componentWillUnmount() {
    // Clear the timer
    if( this.state.timer !== null ) {
      clearInterval( this.state.timer );
    }
  }

  tick() {
    if( this.state.loading === false ) {
      if( this.refreshRatePosition >= this.state.refreshRate ) {
        this.refreshRatePosition = 0;
        // Check if onTick call back was passed to component
        if( this.props.onTick !== undefined ) {
          this.props.onTick( );
        }
      } else {
        this.refreshRatePosition += 1000;
      }
    } else {
      this.refreshPosition = 0;
    }
  }

  render() {
    return ( <span></span> );
  }
}


// WEBPACK FOOTER //
// ./src/presentation/RefreshTimer.js